module.exports = __webpack_public_path__ + "static/media/clipboard-check.9089c64c.svg";